import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';

import { FcApp } from './app/app.module';

if (!/localhost/.test(document.location.host)) {
    enableProdMode();
}

const FcAppPlatform = platformBrowserDynamic();

FcAppPlatform.bootstrapModule(FcApp);
